export const Questions=[
{
    prompt: "What is 2+2+5+1*0+1 ?",
    optionA:"10",
    optionB:"1",
    optionC:"11",
    optionD:"0",
    answer: "A",
},
{
    prompt: "Which of these platforms owned by zuckerburg i:Facebook ii:whatsapp iii:Twitter?",
    optionA:"only i",
    optionB:"ii and iii",
    optionC:"i and ii",
    optionD:"All of these",
    answer: "C",
},
{
    prompt: "What is the value of PI ?",
    optionA:"314",
    optionB:"31.4",
    optionC:"0.314",
    optionD:"3.14",
    answer: "D",
},
];